import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuUserComponent } from './menu-user.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    MenuUserComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatMenu,
    MatMenuTrigger,
    MatButtonModule
  ],
  exports: [
    MenuUserComponent
  ]
})
export class MenuUserModule { }